(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('stickyElm', stickyElm);

    function stickyElm(lodash, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                $(window).scroll((function () {

                    return function () {
                        const elmInstance = elm[0];
                        // const sticky = getPosition(elmInstance).y;
                        const sticky = 180;

                        if (window.pageYOffset >= sticky) {
                            elmInstance.classList.add('sticky');
                        } else {
                            elmInstance.classList.remove('sticky');
                        }
                    };
                })(scope, elm, attrs));
            },
        };
    }
})();